<mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <div class="title-row">
          <span class="card-title">
            <button mat-stroked-button (click)="refreshMessages()" class="icon-only"><mat-icon>refresh</mat-icon></button>
          </span>
          <span class="action-links">
            <a mat-button mat-stroked-button routerLink="/inbox" [matBadge]="ureadMessages" matBadgeOverlap="true" matBadgePosition="before" [matBadgeHidden]="!ureadMessages || ureadMessages === 0"><mat-icon>inbox</mat-icon>Inbox</a>
            <a mat-button mat-stroked-button routerLink="/messages"><mat-icon>search</mat-icon> Search</a>
            @if(clientMatterContactDetails && clientMatterContactDetails.enableMessaging){
              <a mat-button mat-flat-button [routerLink]="getComposeMessageRouterLink()"><mat-icon>add</mat-icon> {{newMessageText}}</a>
            }
          </span>
        </div>
      </mat-card-title>
    </mat-card-header>
  
    <mat-card-content>
      @if(loading){
      <div class="d-flex justify-content-center">
        <mat-spinner></mat-spinner>
      </div>
      }
      @if(pagedSentMessages != null){
        <app-message-list [pagedMessages]="pagedSentMessages"></app-message-list>
      }
       <mat-paginator 
                    (page)="handlePageEvent($event)"
                    [pageSizeOptions]="[5, 10, 20]"
                    [length]="pagedSentMessages?.totalCount"
                    [pageSize]="pageSize"
                    [pageIndex]="pageIndex"               
                    showFirstLastButtons
                 aria-label="Select page of messages">
        </mat-paginator>
      
    </mat-card-content>
  </mat-card>
